module.exports = {
    methods: {
        csrfToken() {
            return document.head.querySelector('meta[name="csrf-token"]').content;
        },

        csrfField() {
            return '<input type="hidden" name="_token" value="' + this.csrfToken() + '" />';
        },

        sleep(time) {
            return new Promise((resolve) => setTimeout(resolve, time));
        },

        setClipboard(value) {
            let tempInput = document.createElement("input");
            tempInput.style = "position: absolute; left: -1000px; top: -1000px";
            tempInput.value = value;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);
        },

        send(data) {
            window.Quiz.$emit('ws-message', data)
        },

        subscribe(channel, data = {}) {
            this.send({
                event: 'subscribe',
                data: {
                    channel: channel,
                    ...data,
                }
            })
        },

        unsubscribe(channel, data = {}) {
            this.send({
                event: 'unsubscribe',
                data: {
                    channel: channel,
                    ...data,
                }
            })
        },

        componentNameFromClass(className) {
            return kebabCase(className.split('\\').slice(-1).pop())
        }
    }
};